/* MAISON KONAN — theme.js */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initSlideshow();
    initGallery();
    initVariantSelects();
    initCartCount();
    initProductRecommendations();
  });

  /* ---- Mobile menu ---- */
  function initMobileMenu() {
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var backdrop = document.querySelector('[data-menu-backdrop]');
    if (!menu) return;

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      if (backdrop) backdrop.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
      toggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(!menu.classList.contains('is-open'));
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () { setOpen(false); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ---- Slideshow ---- */
  function initSlideshow() {
    var root = document.querySelector('[data-slideshow]');
    if (!root) return;

    var slides = root.querySelectorAll('[data-slide]');
    var current = 0;
    if (slides.length < 2) return;

    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    var prev = root.querySelector('[data-slide-prev]');
    var next = root.querySelector('[data-slide-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    var auto = root.dataset.autoPlay === 'true';
    var speed = parseInt(root.dataset.autoPlaySpeed || '5', 10) * 1000;
    if (auto) setInterval(function () { show(current + 1); }, speed);
  }

  /* ---- Product gallery ---- */
  function initGallery() {
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var medias = document.querySelectorAll('[data-gallery-media]');

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        medias.forEach(function (m) { m.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (medias[i]) medias[i].classList.add('is-active');
      });
    });
  }

  /* ---- Variant selects ---- */
  function initVariantSelects() {
    var selects = document.querySelector('[data-variant-selects]');
    if (!selects) return;

    var radios = selects.querySelectorAll('input[type="radio"]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var form = selects.closest('form[data-variant-form]') || selects.closest('form');
        // Optionally update the hidden variant id via AJAX — placeholder for full variant logic.
      });
    });
  }

  /* ---- Cart count ---- */
  function initCartCount() {
    var countEl = document.querySelector('[data-cart-count]');
    if (!countEl || !window.Shopify || !Shopify.theme) return;

    document.addEventListener('cart:updated', function (e) {
      if (countEl && e.detail && typeof e.detail.item_count === 'number') {
        countEl.textContent = e.detail.item_count;
      }
    });
  }

  /* ---- Product recommendations ---- */
  function initProductRecommendations() {
    var blocks = document.querySelectorAll('product-recommendations');
    blocks.forEach(function (block) {
      var url = block.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var inner = html.querySelector('product-recommendations');
          if (inner) block.innerHTML = inner.innerHTML;
        })
        .catch(function () { /* recommendations optional */ });
    });
  }
})();